/* eslint-disable no-underscore-dangle */
import SearchClient from '../search';

/*
Para crearnos una endpoint, primero debemos crearnos una clase que extienda de SearchClient
Aqui definiremos los metodos y el path al que llamaremos en el BACK
Automaticamente cuando realicemos un this.$api.getClient('applications')
El index de src/public/api-client nos creara una instancia en una variable global:
    this.instanced para poder usar los metodos aqui definidos.
*/
export default class ApplicationsClient extends SearchClient {
  constructor(options = {}) {
    super(options);
  }

  getApplicationsStatus = async (data) => {
    try {
      const response = await this.request('get')(
        { data },
        { path: 'gestnotif/applicationsstatus' },
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }
}
